<template>
  <div class="background">
    <div id="app">
      <div class="tabWrap">
        <!-- 这个结构是tab导航，并给其绑定对应的点击事件，在点击事件的回调中
        去控制对应内容的显示隐藏和样式的修改即：tab的切换-->
        <div class="tabNav">
          <div class="navOne" @click="tabOne">时间线</div>
          <div class="navTwo" @click="tabTwo">黑洞图</div>
        </div>
        <!-- 这个结构是tab导航对应的内容 -->
        <div class="tabContent">
          <!-- 通过v-show控制隐藏，同一时刻隐藏一个显示一个，就实现了tab栏的切换效果了 -->
          <div class="navOneBox" v-if="showTabOne"><Duration /></div>
          <div class="navTwoBox" v-if="showTabTwo"><Bar /></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Bar from './Bar'
  import Duration from './Duration'
  export default {
    name: 'ChartTab',
    components: {
      Bar,
      Duration
    },
    data () {
      return {
        baseUrl: 'http://goc6.com',
        score : 100,
        showTabOne: true, // 二选一tab切换
        showTabTwo: false, // 二选一tab切换
      }
    },
    mounted () {
    },
    methods: {
      // 二选一tab栏切换
      tabOne() {
        /*
          点击tab1的时候，让tab1显示，tab2隐藏，即showTabOne为true，showTabTwo为false
          同时修改tab1的样式使其"高亮",注意不要忘了修改tab2的样式，使其"不高亮"。
          点击tab2的时候，也是同理。
        */
        this.showTabOne = true;
        this.showTabTwo = false;
        document.querySelector(".navOne").style.backgroundColor = "#fff";
        document.querySelector(".navTwo").style.backgroundColor = "#e3e3e3";
        document.querySelector(".navOne").style.color = "#3985EC";
        document.querySelector(".navTwo").style.color = "#80868D";
      },
      // 二选一tab栏切换
      tabTwo() {
        this.showTabTwo = true;
        this.showTabOne = false;
        document.querySelector(".navOne").style.backgroundColor = "#e3e3e3";
        document.querySelector(".navTwo").style.backgroundColor = "#fff";
        document.querySelector(".navTwo").style.color = "#3985EC";
        document.querySelector(".navOne").style.color = "#80868D";
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  .background{
    /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
    height: 100%;
    width: 100%;
    background-size: cover;
    position: absolute;
  }

  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/
  #main{
    position: absolute;
    width: 100%;
    height: 80%;
    top: 20%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .left {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
  }
  .right {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
  }
  .thing {
    position: absolute;
    width: 40%;
    top: 30%;
    left: 30%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .tabNav {
    width: 126px;
    height: 30px;
    border-radius: 2px;
    background-color: #e3e3e3;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .navOne {
      width: 60px;
      height: 26px;
      border-radius: 2px;
      background-color: #fff;
      color: #3985ec;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .navTwo {
      width: 60px;
      height: 26px;
      color: #80868d;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .tabContent {
    position: absolute;
    width: 100%;
    height: 80%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
    .navOneBox {
      background-color: #bfa;
    }
    .navTwoBox {
      background-color: #baf;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/game/ChartTab.vue